export default __webpack_public_path__ + "static/media/chat.be496cea.svg";